import { parsePhoneNumberFromString, validatePhoneNumberLength } from 'libphonenumber-js/max';

/** Must match the region the server parses with. */
const DEFAULT_REGION = 'US';

const parse = (value: string) => parsePhoneNumberFromString(value.trim(), DEFAULT_REGION);

/** Undefined for an invalid number or one with an extension, which E.164 can't hold. */
export const toE164 = (value: string): string | undefined => {
  const parsed = parse(value);
  return parsed?.isValid() && !parsed.ext ? parsed.format('E.164') : undefined;
};

/** Splits "212 555 0150 x204" into an E.164 number and extension. */
export const splitExtension = (
  value: string
): { number: string; extension: string } | undefined => {
  const parsed = parse(value);
  return parsed?.isValid() && parsed.ext
    ? { number: parsed.format('E.164'), extension: parsed.ext }
    : undefined;
};

export type PhoneProblem =
  | 'too-short'
  | 'too-long'
  | 'not-a-number'
  | 'unknown-country'
  | 'invalid';

export const phoneProblem = (value: string): PhoneProblem | undefined => {
  if (parse(value)?.isValid()) {
    return undefined;
  }
  switch (validatePhoneNumberLength(value.trim(), DEFAULT_REGION)) {
    case 'TOO_SHORT':
      return 'too-short';
    case 'TOO_LONG':
      return 'too-long';
    case 'NOT_A_NUMBER':
      return 'not-a-number';
    case 'INVALID_COUNTRY':
      return 'unknown-country';
    default:
      return 'invalid';
  }
};
